module.exports = " <md-dialog> <md-dialog-content> <div flex layout=column layout-padding layout-align=start> <h3>{{$ctrl.securityAlertTitle}}</h3> <div class=configuration-item layout=row layout-align=\"start center\" ng-repeat=\"item in $ctrl.securityList\"> <ul> <li>{{item}}</li> </ul> </div> </div> <md-dialog-actions> <md-button class=b-primary ng-click=$ctrl.close()>Got it!</md-button> </md-dialog-actions> </md-dialog-content> </md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./app/data-direct/security-alert.html
// module id = ./app/data-direct/security-alert.html
// module chunks = 8